export const blogData = [
  {
    url: "https://medium.com/p/7faf94241044",
    imageUrl:
      "https://miro.medium.com/v2/resize:fit:0/1*vPQmdoS1IaGyG9CTos14kw.jpeg",
    title: "Recover Binary Search Tree [Leetcode 99]",
    description:
      "This piece aims to solve the recover binary search tree Leetcode 99 problem. Problem Statement: You are given the root of a binary search tree (BST), where the values of exactly two nodes of the tree were swapped by mistake.",
  },
  {
    url: "https://betterprogramming.pub/the-top-7-resources-to-learn-swiftui-328d03e11c7b",
    imageUrl:
      "https://miro.medium.com/v2/resize:fit:0/1*nbqc77lZiNOnx4ODr6W5gQ.jpeg",
    title: "The Top 8 Resources to Learn SwiftUI",
    description:
      "Apple's latest framework SwiftUI was announced at WWDC 19. SwiftUI is an innovative, exceptionally simple way to build user interfaces across all Apple platforms with the power of Swift.",
  },
  {
    url: "https://betterprogramming.pub/build-bar-charts-in-swiftui-372322eea420",
    imageUrl:
      "https://miro.medium.com/v2/resize:fit:720/format:webp/1*BMX5wsjW9ArjhoBMUybaOA.png",
    title: "Build Bar Charts in SwiftUI",
    description:
      "SwiftUI is an innovative, exceptionally simple way to build user interfaces across all Apple platforms with the power of Swift. Build user interfaces for any Apple device using just one set of tools and APIs.",
  },
  {
    url: "https://medium.com/p/a1105ae2cf04",
    imageUrl:
      "https://miro.medium.com/v2/resize:fit:0/1*7zKjE0bIN7pzZaU_y5558Q.jpeg",
    title: "How To Save an Image to Core Data With Swift",
    description:
      "The aim of this piece is to convert a user-picked image into binary data and save that image in core data. Also, we are going to fetch that saved image. We will implement this feature into our sample iOS application.",
  },
];

export default blogData;
